import { DialogBrowserBack } from './components/DialogBrowserBack';
import { FullPageSpinner } from './components/Spinner';
import { RouterProvider, Router } from './router';

function App() {
  // The gate a cold load actually stops at. React Router's `lazy()` is NOT
  // `React.lazy`: it resolves the route module inside the initial navigation
  // and never suspends React, so the `<Suspense>` in `main.tsx` never sees it.
  // Until `state.initialized`, `RouterProvider` renders `fallbackElement ?? null`
  // — so without this the whole first-chunk fetch was a blank white document.
  return (
    <>
      <DialogBrowserBack router={Router} />
      <RouterProvider fallbackElement={<FullPageSpinner />} router={Router} />
    </>
  );
}

export default App;
